import { HttpClient } from '@angular/common/http';
import { OrgModel } from './../../store/storeModels/user.model';
import { Store } from '@ngrx/store';
import { Endpoints } from './../../shared/config/endpoints';
import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { AppState } from 'src/app/store/app.state';

@Injectable({
  providedIn: 'root'
})
export class ReportSettingsService {
  private api = this.endpoint.settingsApi;
  private org: OrgModel
  constructor(
    private endpoint: Endpoints,
    private http: HttpClient,
    store: Store<AppState>) {
      store.select('userInfo').subscribe(info => {
        const { organization} = info;
        this.org = organization;
      })
     }

  getReportConfig() {
    return this.http.get<any>(`${this.api}/reportsConfiguration/${this.org.id}`);
  }
  saveReportConfig(payload) {
    const body = {
      orgID: this.org.id,
      id: 0,
      ...payload
    }
    return this.http.post(`${this.api}/reportsConfiguration`, body)
  }


}
